import { useState, useEffect } from 'react';
import { Provider } from '../types';
import { fetchProviders } from '../api/client';

export function useProviders() {
  const [sttProviders, setSttProviders] = useState<Provider[]>([]);
  const [ttsProviders, setTtsProviders] = useState<Provider[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchProviders()
      .then(({ stt, tts }) => {
        setSttProviders(stt);
        setTtsProviders(tts);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return { sttProviders, ttsProviders, loading, error };
}
